export enum BookletType {
    Written = 0,
    File = 1
}